export const vi = {
  'ad.label': 'Quảng cáo',
  'ad.sponsored_by': 'Được tài trợ bởi {advertiser}',
  'ad.visit': 'Truy cập',
  'cookies.preferences': 'Tùy chọn cookie',
  'cookies.title': 'Quyền riêng tư của bạn, dưới sự kiểm soát của bạn',
  'cookies.description': 'Chúng tôi sử dụng bộ nhớ cần thiết để Albambam hoạt động. Chúng tôi chỉ bật phân tích hoặc tiếp thị khi có sự cho phép của bạn. Bạn có thể rút lại bất cứ lúc nào. Xem',
  'cookies.privacy_link': 'Chính sách bảo mật',
  'cookies.close': 'Đóng tùy chọn',
  'cookies.necessary': 'Cần thiết',
  'cookies.necessary_desc': 'Phiên, bảo mật, ngôn ngữ và các tùy chọn cơ bản.',
  'cookies.analytics': 'Phân tích',
  'cookies.analytics_desc': 'Đo lường sử dụng ẩn danh để cải thiện dịch vụ.',
  'cookies.marketing': 'Tiếp thị',
  'cookies.marketing_desc': 'Cá nhân hóa quảng cáo và đo lường chiến dịch.',
  'cookies.configure': 'Cấu hình',
  'cookies.reject': 'Từ chối tùy chọn',
  'cookies.save': 'Lưu lựa chọn',
  'cookies.accept': 'Chấp nhận tất cả',
  'lang.selector_label': 'Ngôn ngữ',
  'lang.changed': 'Đã đổi ngôn ngữ',
  'nav.home': 'Trang chủ',
  'nav.categories': 'Danh mục',
  'nav.shorts': 'Shorts',
  'nav.friends': 'Bạn bè',
  'nav.upload': 'Tải lên',
  'nav.profile': 'Hồ sơ',
  'nav.login': 'Đăng nhập',
  'common.signed_in': 'Đã đăng nhập',
  'common.error': 'Lỗi',
  'topbar.search_placeholder': 'Tìm video, nhà sáng tạo...',
  'legal.terms': 'Điều khoản',
  'legal.privacy': 'Bảo mật',
  'nav.admin': 'Quản trị',
  'nav.logout': 'Đăng xuất',
  'admin.tab.payments': 'Thanh toán',
  'admin.payments.title': 'Thanh toán',
  'cats.title': 'Danh mục',
  'cats.all': 'Tất cả',
  'cats.adult_title': 'Danh mục 18+',
  'cats.empty': 'Không có video trong danh mục này.',
  'friends.block_confirm': 'Chặn người bạn này? Các bạn sẽ không thể trò chuyện hay xem nhau như bạn bè nữa.',
  'friends.accepted': 'Các bạn đã là bạn bè!',
  'friends.title': 'Bạn bè',
  'friends.subtitle': 'Chỉ những người theo dõi lẫn nhau mới trở thành bạn bè và có thể trò chuyện riêng tư.',
  'friends.unread_count_label': '{n} tin nhắn chưa đọc',
  'friends.blocked_users_title': 'Người dùng bị chặn',
  'friends.unblock_user': 'Bỏ chặn',
  'friends.requests_title': 'Yêu cầu trò chuyện',
  'friends.request_badge': 'Yêu cầu',
  'friends.request_accept': 'Chấp nhận',
  'friends.request_ignore': 'Bỏ qua',
  'friends.empty_title': 'Bạn chưa có bạn bè',
  'friends.empty_subtitle': 'Theo dõi ai đó và được theo dõi lại để mở khóa trò chuyện riêng tư.',
  'friends.attach_image': 'Ảnh',
  'friends.shared_video_label': 'Đã chia sẻ một video',
  'friends.select_conversation': 'Chọn một người bạn để bắt đầu trò chuyện',
  'friends.block_user': 'Chặn',
  'friends.no_messages_yet': 'Chưa có tin nhắn. Hãy chào hỏi!',
  'friends.message_placeholder': 'Viết tin nhắn...',
  'section.trending': 'Thịnh hành',
  'section.shorts': 'Shorts',
  'section.for_you': 'Dành cho bạn',
  'home.hero.badge': 'Chào mừng đến Albambam',
  'home.hero.title_1': 'Video ngắn.',
  'home.hero.title_2': 'Nhà sáng tạo thật.',
  'home.hero.subtitle': 'Xem, chia sẻ và kiếm tiền. Tải lên video của bạn và khám phá tài năng mới trong mọi danh mục.',
  'home.hero.cta_shorts': 'Xem Shorts',
  'home.hero.cta_trending': 'Thịnh hành',
  'home.shorts.see_all': 'Xem tất cả',
  'home.empty.title': 'Chưa có video',
  'home.empty.subtitle': 'Khi nhà sáng tạo tải nội dung lên, chúng sẽ xuất hiện ở đây.',
  'live.send_diamonds': 'Gửi kim cương',
  'live.buy': 'Mua',
  'live.chat': 'Trò chuyện',
  'live.type_message': 'Viết tin nhắn...',
  'live.send': 'Gửi',
  'auth.success_google': 'Đã đăng nhập với Google',
  'auth.fail_google': 'Phiên Google không hợp lệ',
  'auth.success_login': 'Đã đăng nhập',
  'auth.success_register': 'Đã tạo tài khoản',
  'auth.login_tab': 'Đăng nhập',
  'auth.register_tab': 'Tạo tài khoản',
  'auth.email': 'Email',
  'auth.password': 'Mật khẩu',
  'auth.submit_login_loading': 'Đang đăng nhập...',
  'auth.submit_login': 'Đăng nhập',
  'auth.name': 'Tên',
  'auth.submit_register_loading': 'Đang tạo...',
  'auth.submit_register': 'Tạo tài khoản',
  'auth.or': 'hoặc',
  'legal.privacy_title': 'Chính sách bảo mật',
  'search.title': 'Kết quả cho "{q}"',
  'search.count': '{n} video',
  'search.empty': 'Không có kết quả.',
  'series.load_error': 'Không thể tải loạt phim',
  'series.unlocked': 'Đã mở khóa loạt phim',
  'series.purchase_error': 'Không thể bắt đầu giao dịch mua',
  'series.restricted': 'Truy cập bị hạn chế',
  'series.configure_access': 'Cấu hình truy cập',
  'series.language_all': 'Tất cả ngôn ngữ',
  'series.episode_count': '{n} tập',
  'series.buy': 'Mua loạt phim',
  'series.filter_language': 'Lọc theo ngôn ngữ',
  'series.no_episodes': 'Chưa có tập nào được xuất bản.',
  'series.episode_number': 'Tập {n}',
  'legal.terms_title': 'Điều khoản và Điều kiện',
  'lang.ca': 'Tiếng Catalan',
  'lang.en': 'Tiếng Anh',
  'lang.es': 'Tiếng Tây Ban Nha',
  'lang.fr': 'Tiếng Pháp',
  'lang.de': 'Tiếng Đức',
  'lang.it': 'Tiếng Ý',
  'lang.eu': 'Tiếng Basque',
  'lang.gl': 'Tiếng Galician',
  'lang.zh': 'Tiếng Trung',
  'lang.other': 'Khác',
  'lang.vi': 'Tiếng Việt',
  'lang.ja': 'Tiếng Nhật',
  'lang.ko': 'Tiếng Hàn',
  'lang.ru': 'Tiếng Nga',
  'lang.ro': 'Tiếng Romania',
  'lang.ar': 'Tiếng Ả Rập',
  'lang.tr': 'Tiếng Thổ Nhĩ Kỳ',
  'lang.pl': 'Tiếng Ba Lan',
  'lang.ms': 'Tiếng Mã Lai',
  'lang.ta': 'Tiếng Tamil',
  'upload.series_title_error': 'Viết tiêu đề của loạt phim',
  'upload.series_adult_category_error': 'Chọn danh mục 18+ cho loạt phim',
  'upload.series_created': 'Đã tạo loạt phim',
  'upload.series_create_error': 'Không thể tạo loạt phim',
  'upload.err_file': 'Chọn một tệp video hợp lệ',
  'upload.err_title': 'Đặt tiêu đề',
  'upload.series_select_error': 'Chọn hoặc tạo một loạt phim',
  'upload.trailer_target_error': 'Chọn video hoặc loạt phim của đoạn giới thiệu',
  'upload.price_error': 'Nhập giá hợp lệ tối thiểu 0,50 EUR.',
  'upload.adult_category_error': 'Chọn một danh mục người lớn',
  'upload.success': 'Video đã được tải lên thành công',
  'upload.title_h': 'Tải lên video',
  'upload.kind': 'Loại bài đăng',
  'upload.kind_video': 'Video độc lập',
  'upload.kind_episode': 'Tập của loạt phim',
  'upload.kind_trailer': 'Đoạn giới thiệu công khai trong Shorts',
  'upload.series': 'Loạt phim',
  'upload.series_select': 'Chọn một loạt phim',
  'upload.episode': 'Tập',
  'upload.series_new_title': 'Tiêu đề loạt phim mới',
  'upload.series_create': 'Tạo loạt phim',
  'upload.series_adult': 'Loạt phim 18+',
  'upload.series_premium': 'Loạt phim cao cấp',
  'upload.series_adult_category': 'Danh mục 18+ của loạt phim',
  'upload.series_price': 'Giá mỗi tập và gói (EUR)',
  'upload.trailer_for': 'Đoạn giới thiệu giới thiệu',
  'upload.trailer_select': 'Chọn video hoặc loạt phim',
  'upload.video_prefix': 'Video',
  'upload.file_label': 'Tệp video (MP4, tối đa 1GB)',
  'upload.file_pick': 'Nhấp để chọn video',
  'upload.thumb_label': 'Ảnh thu nhỏ (tùy chọn)',
  'upload.video_title': 'Tiêu đề',
  'upload.description': 'Mô tả',
  'upload.category': 'Danh mục',
  'upload.is_short': 'Là Short (dọc)',
  'upload.paid_video': 'Video trả phí',
  'upload.adult_content': 'Nội dung 18+',
  'upload.video_language': 'Ngôn ngữ của video',
  'upload.individual_price': 'Giá để xem video này (EUR)',
  'upload.paid_video_help': 'Người xem mua quyền truy cập vĩnh viễn chỉ cho video này. Giá tối thiểu là 0,50 EUR.',
  'upload.adult_category': 'Danh mục người lớn',
  'upload.uploading': 'Đang tải lên {n}%',
  'upload.submit': 'Tải video lên',
  'user.followers': 'người theo dõi',
  'user.following': 'đang theo dõi',
  'user.follow': 'Theo dõi',
  'user.chat_open': 'Trò chuyện',
  'user.request_sent': 'Đã gửi yêu cầu',
  'user.send_message': 'Gửi tin nhắn',
  'user.followers_title': 'Người theo dõi',
  'user.following_title': 'Đang theo dõi',
  'user.unfollow': 'Bỏ theo dõi',
  'user.request_title': 'Yêu cầu trò chuyện',
  'user.request_subtitle': 'Bạn chỉ có thể gửi một tin nhắn. Nếu họ chấp nhận yêu cầu, các bạn sẽ trở thành bạn bè và có thể trò chuyện.',
  'user.request_placeholder': 'Viết tin nhắn của bạn...',
  'user.request_send': 'Gửi yêu cầu',
  'shorts.login_for_like': 'Đăng nhập để thích',
  'watch.share_copied': 'Đã sao chép liên kết',
  'watch.delete_confirm': 'Xóa bình luận này?',
  'ad.skip_in': 'Bỏ qua sau {n}s',
  'ad.skip': 'Bỏ qua quảng cáo',
  'watch.share': 'Chia sẻ',
  'friends.share_video': 'Chia sẻ video',
  'friends.send': 'Gửi',
  'watch.comments': 'Bình luận',
  'watch.write_comment': 'Viết bình luận...',
  'watch.publish': 'Đăng',
  'watch.login_to_comment': 'Cần đăng nhập để bình luận.',
  'watch.login_btn': 'Đăng nhập để bình luận',
  'watch.no_comments': 'Chưa có bình luận.',
  'watch.related': 'Liên quan',
  'nav.trending': 'Thịnh hành',
  'friends.follow_option_only_follow': 'Theo dõi',
  'friends.follow_option_friends': 'Bạn bè',
  'watch.like': 'Thích',
  'watch.views_short': '{n} lượt xem',
  'shorts.empty.title': 'Chưa có Shorts',
  'shorts.empty.subtitle': 'Tải lên một video ngắn để mở màn mục này.',
  'shorts.share': 'Chia sẻ',
  'auth.continue_google': 'Tiếp tục với Google',
  'upload.is_premium': 'Cao cấp',
  'upload.price': 'Giá (€)',
  'upload.err_select': 'Chọn một video',
  'profile.upload_btn': 'Tải video lên',
  'profile.tab_videos': 'Video của tôi ({n})',
  'profile.tab_history': 'Lịch sử',
  'profile.tab_recos': 'Đề xuất',
  'profile.no_videos': 'Bạn chưa tải lên video nào.',
  'profile.no_history': 'Bạn chưa xem video nào.',
  'profile.no_recos': 'Hãy xem một số video để nhận đề xuất.',
  'profile.likes': 'lượt thích',
  'profile.views': 'lượt xem',
  'wallet.title': 'Ví',
  'wallet.rate_label': 'Tỷ lệ',
  'wallet.min_label': 'Mức rút tối thiểu',
  'wallet.amount_label': 'Số tiền rút',
  'wallet.withdraw_btn': 'Yêu cầu rút tiền',
  'wallet.history_title': 'Lịch sử yêu cầu',
  'wallet.success': 'Đã tạo yêu cầu',
  'wallet.bad_amount': 'Số tiền không hợp lệ',
  'wallet.per_view': '{rate} {cur}/lượt xem',
  'admin.title': 'Quản trị',
  'admin.stats.users': 'Người dùng',
  'admin.stats.videos': 'Video',
  'admin.stats.shorts': 'Shorts',
  'admin.stats.views': 'Lượt xem',
  'admin.tab.videos': 'Video',
  'admin.tab.ads': 'Quảng cáo',
  'admin.tab.users': 'Người dùng',
  'admin.tab.withdrawals': 'Rút tiền',
  'admin.tab.config': 'Cài đặt',
  'admin.tab.translations': 'Ngôn ngữ',
  'tbl.title': 'Tiêu đề',
  'tbl.creator': 'Nhà sáng tạo',
  'tbl.category': 'Danh mục',
  'tbl.type': 'Loại',
  'tbl.views': 'Lượt xem',
  'tbl.likes': 'Lượt thích',
  'tbl.status': 'Trạng thái',
  'tbl.actions': 'Hành động',
  'tbl.placement': 'Vị trí',
  'tbl.advertiser': 'Nhà quảng cáo',
  'tbl.impressions': 'Imp.',
  'tbl.clicks': 'Nhấp',
  'tbl.active': 'Hoạt động',
  'tbl.name': 'Tên',
  'tbl.email': 'Email',
  'tbl.role': 'Vai trò',
  'tbl.wallet': 'Ví',
  'tbl.amount': 'Số tiền',
  'tbl.date': 'Ngày',
  'tbl.user': 'Người dùng',
  'video.video': 'Video',
  'video.short': 'Short',
  'action.show': 'Đăng',
  'action.hide': 'Ẩn',
  'action.delete_confirm_video': 'Xóa video?',
  'ad.create_h': 'Tạo quảng cáo',
  'ad.title_label': 'Tiêu đề',
  'ad.image_label': 'URL hình ảnh',
  'ad.target_label': 'URL đích',
  'ad.advertiser_label': 'Nhà quảng cáo',
  'ad.placement_label': 'Vị trí đặt',
  'ad.placement.banner': 'Banner (trang web)',
  'ad.placement.preroll': 'Pre-roll (trước video)',
  'ad.placement.overlay': 'Overlay (trong video)',
  'ad.active': 'Hoạt động',
  'ad.create_btn': 'Tạo',
  'ad.success_create': 'Đã tạo quảng cáo',
  'ad.delete_confirm': 'Xóa quảng cáo?',
  'users.make_admin': 'Đặt làm admin',
  'users.remove_admin': 'Gỡ admin',
  'wd.approve': 'Duyệt',
  'wd.reject': 'Từ chối',
  'wd.mark_paid': 'Đánh dấu đã thanh toán',
  'wd.empty': 'Không có yêu cầu',
  'cfg.title': 'Cài đặt thanh toán',
  'cfg.rate_label': 'Thanh toán mỗi lượt xem ({cur})',
  'cfg.min_label': 'Mức tối thiểu để rút ({cur})',
  'cfg.currency': 'Tiền tệ',
  'cfg.save': 'Lưu',
  'cfg.saved': 'Đã lưu cài đặt',
  'trans.title': 'Ngôn ngữ và bản dịch',
  'trans.intro': 'Tải lên tệp JSON chứa bản dịch cho bất kỳ mã ngôn ngữ nào (ví dụ: ja, pt, zh). Tệp phải chứa ánh xạ phẳng khóa → văn bản.',
  'trans.code_label': 'Mã ngôn ngữ (ví dụ: ja, pt-BR, zh)',
  'trans.name_label': 'Tên (bằng ngôn ngữ đó)',
  'trans.file_label': 'Tệp JSON bản dịch',
  'trans.upload': 'Tải lên',
  'trans.uploaded': 'Đã lưu bản dịch',
  'trans.delete': 'Xóa',
  'trans.delete_confirm': 'Xóa ngôn ngữ này?',
  'trans.builtin': 'Tích hợp',
  'trans.custom': 'Tùy chỉnh',
  'trans.empty_custom': 'Chưa có ngôn ngữ tùy chỉnh.',
  'common.cancel': 'Hủy',
  'common.loading': 'Đang tải...',
  'common.too_fast': 'Quá nhanh, vui lòng đợi một chút',
  'time.few_seconds': 'vài giây trước',
  'time.min': '{n} phút trước',
  'time.h': '{n} giờ trước',
  'time.d': '{n} ngày trước',
  'time.w': '{n} tuần trước',
  'time.mo': '{n} tháng trước',
  'time.y': '{n} năm trước',
  'brand.tagline': 'Video ngắn. Nhà sáng tạo thật.',
  'live.section': 'Trực tiếp',
  'live.start': 'Bắt đầu phát trực tiếp',
  'live.end': 'Kết thúc phát trực tiếp',
  'live.join': 'Tham gia trực tiếp',
  'live.chat_placeholder': 'Viết tin nhắn...',
  'live.diamond': 'Kim cương',
  'live.buy_access': 'Mua quyền truy cập',
  'live.save_recording': 'Lưu bản ghi',
};
